import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/account/offertes")({
  head: () => ({ meta: [{ title: "Mijn offertes" }, { name: "robots", content: "noindex" }] }),
  component: () => <Outlet />,
});
